import React, { RefObject, useRef, useState } from 'react'
import { Label, CopyIcon, CopyText } from './styles'

export type Props = {
  text: string
  style?: React.CSSProperties
}

export default function Copy({ text, ...props }: Props) {
  const copyRef: RefObject<HTMLTextAreaElement> = useRef(null)
  const [status, setStatus] = useState<string>('')

  const copyToClipboard = async () => {
    try {
      if (copyRef.current) {
        await navigator.clipboard.writeText(copyRef.current.value)
        setStatus('Copied')
        setTimeout(() => setStatus(''), 1500)
      }
    } catch (error) {
      setStatus('Not copied')
      setTimeout(() => setStatus(''), 1500)
    }
  }

  return (
    <Label onClick={copyToClipboard} {...props}>
      <CopyText ref={copyRef} value={text ?? ''} readOnly />
      <CopyIcon />
      <span>{status}</span>
    </Label>
  )
}
